/**
 * Stadium surface type options with i18n keys.
 */
export type StadiumSurfaceCode = "NATURAL_GRASS" | "ARTIFICIAL_TURF" | "HYBRID_GRASS" | "OTHER";

export const SURFACE_OPTIONS: { value: StadiumSurfaceCode; i18nKey: string }[] = [
  { value: "NATURAL_GRASS",   i18nKey: "surface_natural_grass" },
  { value: "ARTIFICIAL_TURF", i18nKey: "surface_artificial_turf" },
  { value: "HYBRID_GRASS",    i18nKey: "surface_hybrid_grass" },
  { value: "OTHER",           i18nKey: "surface_other" },
];